import { gettext } from '@eventbrite/i18n';
import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import { useIsMobileDevice } from '@eventbrite/feature-detection';
import {
    COLLECTION_TO_SLUG_MAPPING,
    PRIDE_COLLECTIONS_TOUCHPOINT_IMAGES,
} from '../../constants';
import React from 'react';
import styles from './PrideCollectionsTouchpoint.module.scss';

export const PrideCollectionsTouchpoint = (props) => {
    const { collectionId } = props;
    const isMobile = useIsMobileDevice();

    if (!Object.hasOwnProperty.call(COLLECTION_TO_SLUG_MAPPING, collectionId)) {
        return null;
    }

    const ctaLink = `/b/${COLLECTION_TO_SLUG_MAPPING[collectionId]}/community/lgbt/`;

    const prideTouchpointTitle = gettext('More ways to celebrate Pride');
    const prideTouchpointSubtitle = !isMobile
        ? gettext('Find unique things to do throughout the month near you')
        : null;

    const touchpointData = [
        {
            className: styles.prideCollectionsTouchpointTitle,
            text: prideTouchpointTitle,
        },
        {
            className: styles.prideCollectionsTouchpointSubtitle,
            text: prideTouchpointSubtitle,
        },
    ];

    return (
        <div className={styles.prideCollectionsTouchpoint}>
            <div className={styles.prideCollectionsTouchpointContainer}>
                <div
                    className={
                        styles.prideCollectionsTouchpointImageTextContainer
                    }
                >
                    <img
                        className={
                            styles.prideCollectionsTouchpointImageContainer
                        }
                        src={
                            isMobile
                                ? PRIDE_COLLECTIONS_TOUCHPOINT_IMAGES[
                                      'imgMobile'
                                  ]
                                : PRIDE_COLLECTIONS_TOUCHPOINT_IMAGES[
                                      'imgDesktop'
                                  ]
                        }
                        alt="Pride Touchpoint"
                    />
                    <div
                        className={
                            styles.prideCollectionsTouchpointTextContainer
                        }
                        data-testid="pride-collections-touchpoint-title-subtitle"
                    >
                        {touchpointData.map((item, index) => (
                            <Typography
                                key={index}
                                as="h2"
                                className={item.className}
                            >
                                {item.text}
                            </Typography>
                        ))}
                    </div>
                </div>
                <a
                    href={ctaLink || ''}
                    data-heap-id="pride_collections_touchpoint_click"
                >
                    <Button className={styles.prideCollectionsTouchpointButton}>
                        <span
                            className={
                                styles.prideCollectionsTouchpointButtonText
                            }
                        >
                            {gettext('Explore events')}
                        </span>
                        <ArrowRightIcon
                            className={
                                styles.prideCollectionsTouchpointArrowRight
                            }
                        />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default PrideCollectionsTouchpoint;
